<script lang="ts" setup>
import { computed, inject, ref, watch } from 'vue'
import { HeaderWrapper, useEventsBus } from '@haskoning/vue-component-library'
import { APP_NAME } from '@/constants'

const authStore = inject('useAuthStore') as any // eslint-disable-line @typescript-eslint/no-explicit-any

const user = computed(() => authStore.user)

const { bus } = useEventsBus()
const loading = ref(false)
watch(
  () => bus.value.get('loading'),
  (val) => {
    val && (loading.value = val[0])
  }
)

function logout() {
  authStore.logout()
}
</script>

<template>
  <HeaderWrapper
    v-if="user"
    :title="APP_NAME"
    :user="user"
    :loading="loading"
    @logout="logout"
  ></HeaderWrapper>
</template>
